import Container from './destinations-container';

export default Container;
